import React, { createContext, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
const menuOnClass = 'fmMainMenu--on';
const localStorageKey = 'fmMainMenuOn';
const SidebarContext = /*#__PURE__*/createContext();
const SidebarProvider = _ref => {
  let {
    children,
    mobileMq = '(max-width: 768px)'
  } = _ref;
  const mediaQuery = useMemo(() => window.matchMedia(mobileMq), [mobileMq]);
  const [isExpanded, setExpanded] = useState(() => {
    const savedState = window.localStorage.getItem(localStorageKey);
    return savedState !== null ? JSON.parse(savedState) : !mediaQuery.matches;
  });
  const [isMobile, setIsMobile] = useState(mediaQuery.matches);
  useEffect(() => {
    if (isExpanded) {
      document.body.classList.add(menuOnClass);
    } else {
      document.body.classList.remove(menuOnClass);
    }
    window.localStorage.setItem(localStorageKey, JSON.stringify(isExpanded));
  }, [isExpanded]);
  useEffect(() => {
    const handleWindowResize = () => {
      setIsMobile(mediaQuery.matches);
    };
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, [mediaQuery.matches]);
  return /*#__PURE__*/React.createElement(SidebarContext.Provider, {
    value: {
      isExpanded,
      isMobile,
      setExpanded
    }
  }, children);
};
const SidebarConsumer = SidebarContext.Consumer;
export { SidebarContext, SidebarProvider, SidebarConsumer };
process.env.NODE_ENV !== "production" ? SidebarProvider.propTypes = {
  children: PropTypes.node.isRequired,
  mobileMq: PropTypes.string
} : void 0;